import { Injectable } from "@angular/core";
import { IInBalanceCheck } from "@tylertech/tyler-api-types";
export class IndexedProvider
{
    ProviderId: string;

    Index: number;
}

@Injectable()
export class InBalanceManagerService
{
    /**
     * TODO - why do we need a service tracking state?
     * @deprecated
     */
    Sorted: Array<IndexedProvider> = [];

    /**
     * TODO - why do we need a service tracking state?
     * @deprecated
     */
    checks: Array<IInBalanceCheck> = [];

    AddToSort(check: IInBalanceCheck): void
    {
        this.checks.push(check);
        this.sort();
    }

    sort(): void
    {
        this.checks.sort((n1, n2) =>
        {
            if (n1.Variance < n2.Variance) return 1;
            else if (n1.Variance > n2.Variance) return -1;
            if (n1.Name > n2.Name) return 1;
            else if (n1.Name < n2.Name) return -1;
            return 0;
        });

        this.checks.forEach((check, index) =>
        {
            const provider = this.Sorted.filter(x => x.ProviderId === check.ProviderId);
            if (provider.length === 0)
            {
                this.Sorted.push(<IndexedProvider>{
                    ProviderId: check.ProviderId,
                    Index: index,
                });
            }
            else
            {
                provider[0].Index = index;
            }
        });
        const sorted = this.Sorted;
        this.Sorted = [];
        Object.assign(this.Sorted, sorted);
    }
}
